import { Injectable } from '@angular/core';
import { IdToTypeConverter } from '@models/imported/createInstanceById';
import { CStampFree } from '@models/imported/SagaSchema/CStampFree';
import { ObjectFactory } from '@services/object-factory/object-factory.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Destination } from '../../schema/destination';
import { DestinationProxyService } from '../destination-proxy/destination-proxy.service';
import { LastDestinationService } from '../last-destination/last-destination.service';

@Injectable()
export class DestinationProviderService {
  private _ready = new BehaviorSubject(false);
  get $ready(): Observable<boolean> {
    return this._ready.asObservable();
  }
  get isReady(): boolean {
    return this._ready.value;
  }

  private _destinations: Destination[] = [];
  get destinations(): Destination[] {
    return this._destinations;
  }

  private selectedDestination: Destination;

  private _current = new BehaviorSubject<Destination>(null);
  get $current(): Observable<Destination> {
    return this._current.asObservable();
  }

  set value(value: Destination) {
    if (this.selectedDestination !== value) {
      this.selectedDestination = value;
      this._current.next(value);
    }
  }

  get value(): Destination {
    return this.selectedDestination;
  }

  constructor(
    private destinationProxy: DestinationProxyService,
    private idToTypeConverter: IdToTypeConverter,
    private objectFactory: ObjectFactory,
    private lastDestination: LastDestinationService
  ) {}

  setup(): void {
    this.lastDestination.setup();
    this.lastDestination.$current.subscribe(
      selectedDestination =>
        (this.value =
          (selectedDestination && this._destinations.find(destination => selectedDestination.Text === destination.Name)) || null)
    );
    this.idToTypeConverter.setConstructorOf(Destination.type, Destination);
    this.destinationProxy.getDestinations().subscribe(destinations => this.createDestinations(destinations));
  }

  private createDestinations(destinations: Destination[]) {
    this.objectFactory.createList(destinations).forEach(destination => this._destinations.push(destination));
    this._ready.next(true);
  }

  select(destination: Destination): Observable<CStampFree> {
    return this.destinationProxy.setDestination(destination).pipe(map(destination => this.objectFactory.create(destination)));
  }
}
